"use client"

import React from 'react'
import { Truck } from 'lucide-react'
import { MedicationCard } from '../../../medication-card'

interface MedicationActiveSubscriptionCardProps {
  medicationName: string
  dosage: string
  supply: string
  status?: 'pending' | 'approved' | 'denied' | 'discontinued' | 'active' | 'shipped' | 'delivered' | 'scheduled'
  estimatedDelivery?: string
  fulfillmentStatus?: string
  nextPrescriptionDue?: string
  variant?: 'shipping' | 'next_month'
  onTitleClick?: () => void
  onBillingClick?: () => void
  hasShippingAddress?: boolean
  onAddShippingAddress?: () => void
  className?: string
}

export const MedicationActiveSubscriptionCard = ({
  medicationName,
  dosage,
  supply,
  status,
  estimatedDelivery,
  fulfillmentStatus,
  nextPrescriptionDue,
  variant = 'shipping',
  onTitleClick,
  onBillingClick,
  hasShippingAddress = true,
  onAddShippingAddress,
  className = "w-full max-w-sm"
}: MedicationActiveSubscriptionCardProps) => {
  const content = {
    title: "Active Subscription",
    description: "View your current medication subscription details and billing information."
  }

  return (
    <div className={`space-y-0 shadow-md rounded-lg bg-transparent ${className}`}>
      {/* Medication Card - no bottom radius, no shadow, no hover effects */}
      <MedicationCard
        medicationName={medicationName}
        dosage={dosage}
        supply={supply}
        status={status}
        estimatedDelivery={estimatedDelivery}
        fulfillmentStatus={fulfillmentStatus}
        nextPrescriptionDue={nextPrescriptionDue}
        onTitleClick={onTitleClick}
        className="w-full rounded-b-none shadow-none"
        disableHover={true}
      />
      
      {/* Active Subscription Section - Clickable title */}
      <div className="rounded-t-none rounded-b-lg p-4 border-l border-r border-b bg-muted/50">
        <div className="flex items-start gap-3 mb-1">
          {onBillingClick ? (
            <button
              onClick={(e) => {
                e.stopPropagation()
                onBillingClick()
              }}
              className="text-base font-semibold leading-none tracking-tight text-foreground hover:underline text-left"
            >
              {content.title}
            </button>
          ) : (
            <h3 className="text-base font-semibold leading-none tracking-tight text-foreground">
              {content.title}
            </h3>
          )}
        </div>
        <p className="text-sm text-muted-foreground mb-3">
          {content.description}
        </p>
        {!hasShippingAddress && onAddShippingAddress && (
          <button 
            className="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-3"
            onClick={onAddShippingAddress}
          >
            <Truck className="h-4 w-4 mr-1" />
            Add Shipping Address
          </button>
        )}
      </div>
    </div>
  )
}